import React from 'react';
import { motion } from 'framer-motion';
import { getAgent } from '../../utils/agents';
import { activeTasks } from '../../utils/dbSelectors';
import { useDb } from '../../hooks/useDb';
import { useMotionPreference } from '../../hooks/useMotionPreference';
import type { AgentId } from '../../types/anna';
interface ThreadPulsesProps {
  stopped: boolean;
  flash: {
    agent: AgentId;
    id: number;
  } | null;
}

/** Bottom edge: one thin line per active agent; the pulse travels at the speed of that task. */
export function ThreadPulses({
  stopped,
  flash
}: ThreadPulsesProps) {
  const reduce = useMotionPreference();
  const tasks = useDb(activeTasks);
  return <ul className="flex items-center gap-4" aria-label="Agents aan het werk" data-id="element-1735" data-mp="1ngmxwo7uxrhs">
      {tasks.map(task => {
      const a = getAgent(task.agent);
      const Icon = a.icon;
      const moving = !stopped && !reduce && task.status === 'bezig';
      return <li key={task.id} className="flex items-center gap-2" data-id="element-1736" data-mp="1iiv8q1ylkjha">
            <Icon className="h-6 w-6 shrink-0" style={{
          color: stopped ? '#9AA6B5' : a.color
        }} strokeWidth={1.75} aria-hidden data-id="element-1737" data-mp="2932168lvb7s4" />
            <span className="sr-only" data-id="element-1738" data-mp="2448m4bqxn8pu">
              {a.name}: {task.title}, {task.status === 'wacht' ? 'wacht op jou' : `stap ${task.step} van ${task.totalSteps}`}
            </span>
            <span aria-hidden className="relative block h-[3px] w-10 overflow-hidden rounded-full 2xl:w-16" style={{
          backgroundColor: stopped ? 'rgba(255,255,255,0.1)' : `${a.color}33`
        }} data-id="element-1739" data-mp="2e3zjqmasi3u5">
              {moving && <motion.span className="absolute inset-y-0 w-4 rounded-full" style={{
            backgroundColor: a.color
          }} initial={{
            left: '-30%'
          }} animate={{
            left: '110%'
          }} transition={{
            duration: 2.4 / Math.max(0.1, task.pace),
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-1740" data-mp="203oprae6o94r" />}
              {!moving && !stopped && task.status === 'wacht' && <span className="absolute inset-y-0 left-0 w-full rounded-full" style={{
            backgroundColor: `${a.color}99`
          }} data-id="element-1741" data-mp="1sbodl8qs67cm" />}
              {flash?.agent === task.agent && <motion.span key={flash.id} className="absolute inset-0 rounded-full" style={{
            backgroundColor: a.color
          }} initial={{
            opacity: 1
          }} animate={{
            opacity: 0
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} data-id="element-1742" data-mp="214ry20zufkgr" />}
            </span>
          </li>;
    })}
    </ul>;
}